import * as types from '../const/action.types';
import api from '../api/ProcessApi';

export function processHasErrored(bool, message) {
    return {
        type: types.PROCESS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function processIsLoading(bool) {
    return {
        type: types.PROCESS_IS_LOADING,
        isLoading: bool,
    };
}

export function processFetchDataSuccess(items) {
    return {
        type: types.PROCESS_FETCH_DATA,
        items,
    };
}

export function processFetchMessagesSuccess(messages) {
    return {
        type: types.PROCESS_MESSAGES,
        messages,
    };
}

export function setParamters(lastWeek, from, to, ended, local) {
    return {
        type: types.SET_PARAMETERS_LOAD,
        from,
        to,
        ended,
        local,
        lastWeek,
    };
}

export function loadProcesses(lastWeek, from, to, ended, local) {
    return async (dispatch) => {
        dispatch(processIsLoading(true));
        dispatch(processHasErrored(false, ''));
        dispatch(loadInstancesOpened(lastWeek, from, to, ended, local));
        return api
            .get(lastWeek, from, to, ended, local)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response.message);
                }
                const processes = response;
                dispatch(processIsLoading(false));
                dispatch(processHasErrored(false, ''));
                dispatch(processFetchDataSuccess(processes.process));
                dispatch(processFetchMessagesSuccess(processes.messages ? processes.messages : []));
                return response;
            })
            .catch((error) => {
                console.error(error);
                if (error.response) {
                    dispatch(processIsLoading(false));
                    dispatch(processHasErrored(error.type ? error.type : true, error.message));
                } else {
                    dispatch(processIsLoading(false));
                    dispatch(processHasErrored(false, ''));
                }
            });
    };
}

export function loadInstancesOpened(lastWeek, from, to, ended, local) {
    return async (dispatch) => {
        return api
            .getInstancesOpened(lastWeek, from, to, ended, local)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response.message);
                }
                dispatch(processInstancesOpenedSuccess(response.data ? response.data : []));
                return true;
            })
            .catch((error) => {
                console.error(error);
            });
    };
}

export function processInstancesOpenedSuccess(instances) {
    return {
        type: types.INSTANCE_OPENED_FETCH_DATA,
        instances,
    };
}

export function cleanMessages() {
    return async (dispatch) => {
        dispatch(processFetchMessagesSuccess([]));
    };
}

export function getHistorial(id) {
    return async (dispatch) => {
        return api
            .getHistorial(id)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response.message);
                }
                return response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.process.actions.js